<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>配信履歴</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="my-3 table-outline bg-white"
              :items="tableItems"
              :fields="tableFields"
              column-filter
              sorter
              head-color="light"
              :items-per-page="10"
              size="sm"
              pagination
            >
              <td slot="taskID" class="text-left" slot-scope="{ item }">
                <span>{{ item.taskID }}</span>
              </td>
              <td slot="template" class="text-left" slot-scope="{ item }">
                <strong>{{ item.template }}</strong>
              </td>
              <td slot="sendTime" class="text-left" slot-scope="{ item }">
                <span>{{ item.sendTime | formatTime }}</span>
              </td>
              <td slot="deliveryTime" class="text-left" slot-scope="{ item }">
                <span>{{ item.deliveryTime | formatTime }}</span>
              </td>
              <td slot="totalDelivery" class="text-left" slot-scope="{ item }">
                <strong>{{ item.totalDelivery }}</strong>
              </td>
            </CDataTable>
          </CCardBody>
          <CCardFooter> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
  </div>
</template>

<script>
export default {
  name: "配達履歴",
  data() {
    return {
      tableItems: [
        {
          taskID: "323",
          template: "New Year Event",
          sendTime: "20210101",
          deliveryTime: "20210102",
          totalDelivery: "1221",
        },
        {
          taskID: "443",
          template: "New Event",
          sendTime: "20210104",
          deliveryTime: "20210105",
          totalDelivery: "2211",
        },
      ],
      tableFields: [
        { key: "taskID", label: "テンプレート", _classes: "text-left bg-light", _style:"width:10%" },
        { key: "template", label: "テンプレート", _classes: "text-left bg-light" },
        { key: "sendTime", label: "送信時間", _classes: "text-left bg-light" },
        { key: "deliveryTime", label: "完了時間", _classes: "text-left bg-light" },
        { key: "totalDelivery", label: "送信件数", _classes: "text-left bg-light", _style:"width:10%" },
      ],
    };
  },
  //入力項目にvalidation
  validations: {},
  beforeMount() {},
  methods: {
    goETemplateCreate() {
      this.$router.push({
        name: "配信テンプレート作成",
      });
    },
    goTempalteEdit() {
      this.$router.push({
        name: "テンプレート編集",
      });
    },
  },
};
</script>
